import { Flex, Stack } from '@chakra-ui/react';

import { CompanyProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import {
  formatLegalAnnualTurnOver,
  formatLegalNumberOfEmployeeRange,
} from 'features/Onboarding/common/complianceProperties';
import InformationSection, {
  InformationSectionItem,
} from 'features/Onboarding/components/InformationSection';
import OBBackButton from 'features/Onboarding/components/OBBackButton';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import getIsEi from 'features/Onboarding/lib/getIsEi';

import Header from '../../../../components/Header';
import locales from './locales';

interface FinancialInfoReviewProps {
  companyData: Pick<
    CompanyProfile,
    | 'legalForm'
    | 'legalAnnualTurnOver'
    | 'legalNumberOfEmployeeRange'
    | 'legalShareCapital'
  >;
  onEdit: () => void;
}

const getFinancialSectionItems = (
  company: FinancialInfoReviewProps['companyData'],
): InformationSectionItem[] => {
  const { legalAnnualTurnOver, legalNumberOfEmployeeRange, legalShareCapital } =
    company;

  const items: InformationSectionItem[] = [];

  if (!getIsEi(company)) {
    items.push([locales.capital, legalShareCapital?.toString() ?? '']);
  }

  items.push(
    [
      locales.employees,
      formatLegalNumberOfEmployeeRange(legalNumberOfEmployeeRange),
    ],
    [locales.turnover, formatLegalAnnualTurnOver(legalAnnualTurnOver)],
  );

  return items;
};

const FinancialInfoReview = asBentoPage<FinancialInfoReviewProps>(
  ({ companyData, Layout, onEdit, onPrev }) => {
    return (
      <Layout
        data-testid="info-verification"
        header={<OBBackButton onClick={onPrev} />}
        nav={<OBNavigation onPrev={onPrev} />}
      >
        <Flex direction="column" height={{ base: 'full', md: 'auto' }}>
          <Header title={locales.title} />

          <Stack spacing="space-24">
            <InformationSection
              iconName="building"
              items={getFinancialSectionItems(companyData)}
              onEdit={onEdit}
              title={locales.financialData}
            />
          </Stack>
        </Flex>
      </Layout>
    );
  },
);

export default FinancialInfoReview;
